import { TabBehavior } from '../../objectScreen.types';

export function activateTab(
  behavior: TabBehavior,
  tabKey: string,
  setActiveTab: (tabKey: string) => void,
) {
  if (behavior === 'anchor') {
    document.getElementById(`object-section-${tabKey}`)?.scrollIntoView({ behavior: 'smooth' });
    return;
  }

  setActiveTab(tabKey);
}
